import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  showArrow?: boolean;
};
export function CtaButton({
  children,
  href = '#offre',
  className = '',
  showArrow = true
}: CtaButtonProps) {
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-8 py-4 text-base font-bold text-white shadow-lg shadow-brand/25 transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand-dark hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand ${className}`} data-id="element-39" data-mp="cl2gsarelron">
      {children}
      {showArrow && <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-40" data-mp="vclime9oyzp3" />}
    </a>;
}